import { throttle } from "lodash";
import { useEffect, useState } from "react";

export const useMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 784);

  useEffect(() => {
    const handleResize = throttle(() => {
      setIsMobile(window.innerWidth < 784);
    }, 200);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};
